import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';
import { RequireAdmin } from './Layout.tsx';
import { LoginPage } from './pages/Login.tsx';
import { DashboardPage } from './pages/Dashboard.tsx';
import { CandidatesPage } from './pages/Candidates.tsx';
import { CandidateFormPage } from './pages/CandidateForm.tsx';
import { LegalPage } from './pages/Legal.tsx';

export const adminRoutes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <RequireAdmin />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'candidates', element: <CandidatesPage /> },
      { path: 'candidates/new', element: <CandidateFormPage key='new' mode='create' /> },
      { path: 'candidates/:id/edit', element: <CandidateFormPage key='edit' mode='edit' /> },
      { path: 'legal', element: <LegalPage /> },
      { path: '*', element: <Navigate to='/' replace /> },
    ],
  },
];
